import { useMemo } from "react";
import qrcode from "qrcode-generator";

interface Props {
  value: string;
  className?: string;
  alt?: string;
}

/** QR Code real (nivel M), desenhado no navegador; nada sai do sistema. */
export default function QrCode({ value, className, alt = "QR Code" }: Props) {
  const src = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(value);
    qr.make();
    return qr.createDataURL(4, 0);
  }, [value]);
  return <img src={src} alt={alt} className={className} style={{ imageRendering: "pixelated" }} />;
}

/** Endereco publico da ficha do exemplar, o mesmo do QR Code do PDF. */
export function fichaUrl(treeId: number | string): string {
  return `${window.location.origin}/cta/${treeId}`;
}
